import { memo, useContext } from 'react';
import ReactMarkdown from 'react-markdown';

// Components
import { Context } from '@/components/Store';

const SmartDescription = () => {
  const [state] = useContext(Context);

  const Description = memo(({ content }: { content: string | undefined }) => (
    <ReactMarkdown skipHtml={true}>{content ? content.replaceAll(/<br\s?\/?>/g, '\n') : ''}</ReactMarkdown>
  ));

  return (
    <div className="product-description">
      <Description content={state?.bundle?.description} />
    </div>
  );
};

export { SmartDescription };
